import { Koi } from '@ksyos/koi';

export type JSONValue = string | number | boolean | null | { [x: string]: JSONValue } | Array<JSONValue>;

export type DefinedCustomControlData = { [key: string]: JSONValue };
export const definedCustomControlDataSchema = Koi.object().pattern(Koi.string(), Koi.any()).required();

export type CustomControlData = DefinedCustomControlData | null;

export function isDefinedJSONObject(data: unknown): data is DefinedCustomControlData {
    return !definedCustomControlDataSchema.validate(data).error;
}

export function isJSONValue(data: unknown): data is JSONValue {
    const definedJSONValueSchema = Koi.alternatives()
        .try(Koi.string(), Koi.number(), Koi.boolean(), definedCustomControlDataSchema, Koi.array().items(Koi.any()))
        .allow(null)
        .required();

    return !definedJSONValueSchema.validate(data).error;
}
